import './Catalog.css';

export default function Catalog({ item }) {
    return (
        // used for image on left and text right 
        <div className="d-flex shadow rounded">
            <div className="col-4">
                <img src={item.src} className="img-thumbnail float-start" alt="catalog-image" />
            </div>
            <div className="col-8">

                <div className="row m-1">
                    <div className="text-primary-emphasis mt-2 fs-3">
                        {item.link ? (
                            <a href={item.link} className='custom-link' target="_blank" rel="noopener noreferrer">
                                {item.title}
                            </a>
                        ) : (
                            item.title
                        )}
                    </div>
                    <div className="pxy-2 overflow-y-auto">
                        {item.text}
                    </div>
                </div>
            </div>
        </div>
    )
}